import { type CustomerConfigState } from '../NavigationMapView';
import {
  type INavigationConfigDBItem,
  type NavItemSkeleton,
} from '../types/types';
import { ENVIRONMENTS_OPTIONS, ROLES_OPTIONS } from './constants';

export const camelCaseToNormal = (text: string): string => {
  return text
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/^./, (char) => char.toUpperCase());
};

export const getNavTranslationKey = (id: string): string => {
  return id.replace(/([A-Z])/g, '_$1').toLowerCase();
};

export const getSkeleton = (
  items: any[],
  depth: number = 0,
  parentId: string | null = null
): NavItemSkeleton[] => {
  let result: NavItemSkeleton[] = [];
  items.forEach((item) => {
    result.push({
      id: item.id,
      path: item.path,
      depth,
      hasChildren: item.children && item.children.length > 0,
      icon: item.icon,
      defaultLabel: item.id,
      parentId,
    });
    if (item.children) {
      result = [...result, ...getSkeleton(item.children, depth + 1, item.id)];
    }
  });
  return result;
};

export const createDefaultConfig = (
  skeleton: NavItemSkeleton[],
  fetchedConfig?: INavigationConfigDBItem[],
  t?: (key: string, fallback: string) => string
): CustomerConfigState => {
  const config: CustomerConfigState = {};

  const fetchedConfigMapById: Record<string, INavigationConfigDBItem> = {};

  fetchedConfig?.forEach((el) => {
    if (!fetchedConfigMapById[el.id]) {
      fetchedConfigMapById[el.id] = el;
    }
  });

  skeleton.forEach((node) => {
    const fetchedConfigById = fetchedConfigMapById?.[node?.id];
    config[node.id] = {
      webEnabled: fetchedConfigById?.webEnabled ?? false,
      appEnabled: fetchedConfigById?.appEnabled ?? false,
      label:
        fetchedConfigById?.label ??
        t?.(
          getNavTranslationKey(node.id),
          camelCaseToNormal(node.defaultLabel)
        ) ??
        camelCaseToNormal(node.defaultLabel),
      roles: fetchedConfigById?.roles ?? ROLES_OPTIONS,
      environments: fetchedConfigById?.environments ?? ENVIRONMENTS_OPTIONS,
      invisible: fetchedConfigById?.invisible ?? false,
      path: fetchedConfigById?.path ?? '',
      id: node.id,
      customerCode: fetchedConfigById?.customerCode,
      showPro: fetchedConfigById?.showPro ?? false,
      module: fetchedConfigById?.module ?? '',
    };
  });
  return config;
};
